export const GLOBAL = {
  rename: 'Rename',
  delete: 'Delete',
  edit: 'Edit',
  save: 'Save',
  restore: 'Restore',
  new: 'New',
  active: 'Active',
  completed: 'Completed',
  closed: 'Closed',
  percent: 'Percent',
  count: 'Count',
  allStatus: 'All status',
  allGoals: 'All goals',
  filters: 'Filters',
  reset: 'Reset',
  applyFilters: 'Apply Filters',
  goals: 'Goals',
  goal: 'Goal',
  vote: 'Vote',
  votes: 'Votes',
  deleteItemText: 'Are you sure you want to delete this',
  cancel: 'Cancel',
  confirm: 'Confirm',
  name: 'Name',
  description: 'Description',
  owner: 'Owner',
  contributor: 'Contributor',
  contributors: 'Contributors',
  dueDate: 'Due date',
  due: 'Due',
  status: 'Status',
  typeHere: 'Type here',
  pickGoal: 'Pick a goal',
  selected: 'Selected',
  pending: 'Pending',
  inProgress: 'In progress',
  day: 'Day',
  days: 'Days',
  noOwners: 'No owners',
  noPeople: 'No people',
  noTeams: 'No teams',
  people: 'People',
  teams: 'Teams',
  noContributors: 'No contributors',
  search: 'Search',
  start: 'Start',
  send: 'Send',
  sortBy: 'Sort by',
  moreOptions: 'More options',
  comments: 'Comments',
  showLess: 'Show less',
  seeAllComments: 'See all comments',
  goBack: 'Go back',
  home: 'Home',
  analytics: 'Analytics',
  admin: 'Admin',
  settings: 'Settings',
  download: 'Download',
  create: 'Create',
  opened: 'Opened',
  update: 'Update',
  required: 'is required',
  noData: 'No Data',
  somethingWentWrong: 'Something went wrong',
  '404': 'Error 404 - Page not found',
  goHome: 'Go Home',
  noFolders: 'There are no folders',
  createFolders: 'To use Empower, create a folder in Employee Experience.',
  initiatives: 'Initiatives',
  filter_statuses: 'Select status',
  filter_goals: 'Select goals',
  filter_dates: 'Select dates',
  allOwners: 'All owners',
  by: 'By',
  saveChanges: 'Save changes',
  deleteTemplate: 'Delete template',
  deleteTemplateText: 'Are you sure you want to delete template?',
  path: 'Path',
  date: 'Date',
  time: 'Time',
  message: 'Message',
  type: 'Type',
  method: 'Method',
  'in progress': 'In progress',
  emailAddress: 'Email Address',
  companyName: 'Company Name',
  organizationId: 'Organization Id',
  organizationApiKey: 'Organization ApiKey',
  emailSubscribed: 'Emails subscribed',
  logout: 'Logout',
  empower: 'Empower',
  pickAnItem: 'Pick an item form the Folder list to get started.',
  workforce: 'Workforce',
  survey: 'Survey',
  deleteAll: 'Delete all',
  uptream: 'Upstream',
  downstream: 'Downstream',
  selectType: 'Select type',
  none: 'None',
  conversation: 'Conversation',
  conversations: 'Conversations',
  highlight: 'Highlight',
  close: 'Close',
  open: 'Open',
  unhide: 'Unhide',
  teamView: 'Team view',
  notApplicable: 'N/A',
  data: 'Data',
  infoMessage: 'Info Message',
  loading: 'Loading...',
  employeeExperience: 'Employee Experience',
  upgradeToUnlock: 'Upgrade to unlock',
  waiting: 'Waiting',
  title: 'Title',
  like: 'Like',
  removeLogo: 'remove logo',
  help: 'Help',
  breadcrumb: 'Breadcrumb',
  menu: 'Menu',
} as const
